import { BASE_DATE_FORMAT } from '@seeneco-ui/core/constants';
import * as moment from 'moment';

import {
	ActionResponse,
	StoreAsyncItem,
	checkAsyncAction,
	createAsyncInitialState,
	createReducer,
	invalidateStateFromAction,
} from '@flux';
import { mainLeadsActionsPack } from '../actions';

export type MainLeadsState = {
	dateRange: DateRange;
	leads: StoreAsyncItem<Array<Lead>>;
	newLeadSmsText: StoreAsyncItem<string>;
};

const initialState: MainLeadsState = {
	dateRange: {
		dateStart: moment().startOf('quarter').format(BASE_DATE_FORMAT),
		dateEnd: moment().endOf('quarter').format(BASE_DATE_FORMAT),
	},
	leads: createAsyncInitialState([]),
	newLeadSmsText: createAsyncInitialState(''),
};

const mainLeadsReducer = createReducer(initialState, {
	[mainLeadsActionsPack.types.ADD_LEAD]: (action: ActionResponse<Lead>, state) => {
		return {
			leads: invalidateStateFromAction(action, state.leads),
		};
	},
	[mainLeadsActionsPack.types.FETCH_LEADS]: (action: ActionResponse<Array<Lead>>, state) => {
		return {
			leads: checkAsyncAction(action, state.leads),
		};
	},
	[mainLeadsActionsPack.types.FETCH_NEW_LEAD_SMS_TEXT]: (action: ActionResponse<string>, state) => {
		return {
			newLeadSmsText: checkAsyncAction(action, state.newLeadSmsText),
		};
	},
	[mainLeadsActionsPack.types.INVALIDATE_LEADS]: (action: ActionResponse<void>, state) => {
		return {
			leads: invalidateStateFromAction(action, state.leads),
		};
	},
	[mainLeadsActionsPack.types.SEND_EMAIL_NOTIFICATION]: (action: ActionResponse<boolean>, state) => {
		return {
			leads: invalidateStateFromAction(action, state.leads),
		};
	},
	[mainLeadsActionsPack.types.SET_DATE_RANGE]: (action: ActionResponse<DateRange>, state) => {
		return {
			dateRange: action.payload.value,
			leads: invalidateStateFromAction(action, state.leads),
		};
	},
	[mainLeadsActionsPack.types.UPDATE_LEAD]: (action: ActionResponse<Lead>, state) => {
		return {
			leads: invalidateStateFromAction(action, state.leads),
		};
	},
});

export default mainLeadsReducer;
